// extracted by mini-css-extract-plugin
export default {"tabsList":"Tabs_tabsList__5rysB","tabsTrigger":"Tabs_tabsTrigger__eATpM","tabsContent":"Tabs_tabsContent__Hb-76"};